import { useCallback } from "react";
import { Breadcrumbs } from "~/components/UI";
import { useTranslation } from "react-i18next";
import AuditKeyManagement from "./AuditKeyManagement";

/**
 * @namespace AuditKeyManagement
 */

const AuditKeyManagementPage = () => {
  const { t } = useTranslation();

  const getBreadcrumbs = useCallback(() => {
    return [
      { label: t("title.journals") },
      { label: t("title.auditKeyManagement") },
    ];
  }, [t]);

  return (
    <>
      <Breadcrumbs links={getBreadcrumbs()} />
      <AuditKeyManagement />
    </>
  );
};

export default AuditKeyManagementPage;
